import { useSelector, shallowEqual } from 'react-redux';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { useMeterType } from './useMeterType';

export const useMeterValidation = () => {
  const address = useSelector(selectedAddress, shallowEqual);
  const { hasElectricityMeter, hasGasMeter } = useMeterType();
  const hasAddress = !!address;
  const hasAnyMeterValidationRequired =
    hasAddress && (!hasElectricityMeter || !hasGasMeter);
  return { hasAnyMeterValidationRequired };
};
